export const MENU_MODULE_LIST = [
    { value: 1, label: '图形', },
    { value: 2, label: '规划', },
    { value: 3, label: '建筑', },
    { value: 4, label: '结构', },
    { value: 5, label: '暖通空调', },
    { value: 6, label: '给排水', },
    { value: 7, label: '电气', },
    { value: 8, label: '消防', },
    { value: 9, label: '运维', },
]

export const MENU_MODULE = {
    GEOMETRY: 1,
    PLANNING: 2,
    BUILDING: 3,
    STRUCTURE: 4,
    HAVC: 5,
    WATER: 6,
    ELECTRICITY: 7,
    FIRE: 8,
    MAINT: 9,
}

export function getMenuModule(value: number) {
    return MENU_MODULE_LIST.find(item => item.value === value) || null
}